import React from 'react'
import { connect } from 'react-redux'
import { createIdea } from 'services/create_idea'
import Navigation from 'support/navigation'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'
import ErrorSubmitModal from './ErrorSubmitContainer'
import SuccessSubmitModal from './SucessSubmitContainer'

import { showPopupSuccessSnackbar } from 'support/popup_dialogs/index'
import { getIdeaInnovateDetail,getListEvaluatorAssignedForIdea,getShowPopupForEvaluatorScorecardAssignedIdea, putInnovateIdeaEvaluatorRatingEdit } from 'services/innovate/idea'

const mapStateToProps = () => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  // description: i18n.t('EXPLORE_IDEA.PUBLISH_CONFIRM'),
  description: 'Are you sure you want to save the updated scorecard rating for this idea?',
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  // console.log("Rating Scorecard Call API===> ,", ownProps)
  const  {ideaIdKey:id,businessSCFlag,userEmail} = ownProps.postSaveEvaluatorFormParams
  const paramsForShowPopupData = {
    ideaId:id,
    businessSCFlag,
    userEmail,
  }
  return {
    mainButtonAction : ()=>{
      const onSuccess = response => {      
        // dispatch(Navigation.navigateBack())
        dispatch(Navigation.navigateToEvaluationBoard())
        dispatch(getListEvaluatorAssignedForIdea(id))
        dispatch(getIdeaInnovateDetail(id))
        dispatch(getShowPopupForEvaluatorScorecardAssignedIdea(paramsForShowPopupData))
        // showPopupDialog(<SuccessSubmitModal description='Your idea has been successfully evaluated!' />, dispatch)
        showPopupSuccessSnackbar('Your idea has been successfully Save!', dispatch)
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data?.error && data?.error?.en
            ? `BACKEND_ERRORS.${data?.error?.en}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorSubmitModal description={i18n.t(messageTag)} />, dispatch)
      }
      dispatch(putInnovateIdeaEvaluatorRatingEdit(ownProps.postSaveEvaluatorFormParams, onSuccess, onFailure))
      dispatch(hideDialog())
    }, 

    cancelButtonAction: () => dispatch(hideDialog()),
    
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
